import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useIsMobile as useIsMobileHook } from "../../hooks/useIsMobile";
import { Capacitor } from "@capacitor/core";

const MobileNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useIsMobileHook();
    const navigateToPage = (destinationPage) => {
        if (location.pathname !== destinationPage) {
            navigate(destinationPage);
        }
    };

    const showCalendarPage = () => {
        let showCalendarPage = useSelector((state) => state.showCalendarPage);

        if (showCalendarPage) {
            if (Capacitor.isNativePlatform()) {
                return false;
            }
        }
        return showCalendarPage;
    };

    return (
        <div className="gt-nav">
            <button className={`gt-nav__button ${location.pathname.toLowerCase().trim() === "/overview" ? "active" : ""
                }`} onClick={() => {
                navigateToPage("/Overview");
            }}>
                <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-home"></use>
                </svg>
                Overview
            </button>
            {showCalendarPage() && (
                <button className={`gt-nav__button ${location.pathname.toLowerCase().trim() === "/calendar" ? "active" : ""
                }`} onClick={() => {
                    navigateToPage("/Calendar");
                }}>
                <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-calendar"></use>
                </svg>
                Calendar
            </button>
            )}
            <button className={`gt-nav__button ${location.pathname.toLowerCase().trim() === "/todo" ? "active" : ""
                }`} onClick={() => {
                navigateToPage("/Todo");
            }}>
                <svg viewBox="0 0 15 19" xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-todo"></use>
                </svg>
                To-do
            </button>
            <button className={`gt-nav__button ${location.pathname.toLowerCase().trim() === "/due-dates" ? "active" : ""
                }`} onClick={() => {
                navigateToPage("/Due-dates");
            }}>
                <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-due-date"></use>
                </svg>
                Due Dates
            </button>
        </div>
    );

};

export default MobileNav;
